import styles from "./HL7DetailsTab.module.css";

// Fallback shown only when the HL7 document can't be rendered via XSLT. The
// parsed test results live in the main results table above, so here we keep
// just the patient summary.
export const HL7DetailsTab = ({ loading, hl7Details }) => {
  if (loading || !hl7Details) {
    return (
      <div className={styles.emptyState}>
        <p className={styles.emptyStateTitle}>Loading results...</p>
        <p className={styles.emptyStateText}>
          Please wait while we fetch the results.
        </p>
      </div>
    );
  }

  if (!hl7Details.patientDemographics) return null;

  const { address, dateOfBirth, patientName, mrn, gender } =
    hl7Details.patientDemographics;

  const patientSummary = `${address || ""} ${mrn || ""} ${patientName || ""} (${dateOfBirth || ""} - ${gender || ""})`;

  return (
    <div className={styles.hl7Container}>
      <div className={styles.hl7Section}>
        <h3 className={styles.hl7SectionTitle}>Patient Summary</h3>
        <p className={styles.patientSummaryText}>{patientSummary}</p>
      </div>
    </div>
  );
};
